import { useEffect, useMemo, useState } from "react";
import { emptyFilters } from "../../railway-query/config";
import { dateTabs, retainAvailableFilters } from "../../railway-query/service";
import type { RailwayFilters, RailwaySort, RailwayTicketsData } from "../../railway-query/types";
import { filterRailwayTransfers, railwayTransferFilterTrains, sortRailwayTransfers } from "../service/itineraryRailwayTransferFilterService";
import type { RailwayTransferSearchResult } from "../types";

type Props = {
  result: RailwayTransferSearchResult | null; queriedAt: string;
  date: string; minDate: string; maxDate: string; fromName: string; toName: string;
  onSelectDate: (date: string) => void;
};

/** 复用直达全部筛选与日期控件；筛选只改变展示，不写入查询或主备状态。 */
export function useItineraryRailwayTransferView(props: Props) {
  const [filters, setFilters] = useState(emptyFilters);
  const [sort, setSort] = useState<RailwaySort>({ key: "depart", direction: "asc" });
  const [filtersOpen, setFiltersOpen] = useState(true);
  const data = useMemo<RailwayTicketsData | undefined>(() => props.result ? {
    date: props.result.queryDate, from_station: props.fromName, to_station: props.toName, purpose: "ADULT",
    queried_at: props.queriedAt, min_date: props.minDate, max_date: props.maxDate, window_source: "fallback",
    trains: railwayTransferFilterTrains(props.result.transfers),
  } : undefined, [props.result, props.fromName, props.toName, props.queriedAt, props.minDate, props.maxDate]);
  useEffect(() => { if (data) setFilters((value) => retainAvailableFilters(value, data.trains)); }, [data]);
  const query = { date: data?.date ?? props.date, from_station: props.fromName, to_station: props.toName, purpose: "ADULT" as const };
  return {
    data, query, filters, setFilters, filtersOpen, setFiltersOpen, sort, setSort,
    transfers: sortRailwayTransfers(filterRailwayTransfers(props.result?.transfers ?? [], filters), sort),
    dates: dateTabs(props.minDate, props.maxDate, query.date), selectDate: props.onSelectDate,
    updateFilters: (patch: Partial<RailwayFilters>) => setFilters((value) => ({ ...value, ...patch })),
    toggleSort: (key: RailwaySort["key"]) => setSort((value) => ({ key, direction: value.key === key && value.direction === "asc" ? "desc" : "asc" })),
  };
}
